module.exports = __webpack_public_path__ + "static/img/avatar.6696b033.png";